import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Korisnik } from '../../common/types/types';

const initialState: Korisnik = {
  id: null,
  first_name: '',
  last_name: '',
  username: 'null',
  email: 'null',
  admin: false,

  accessToken: null,
  refreshToken: null,

  credentialsError: '',
};

const korisnikSlice = createSlice({
  name: 'korisnik',
  initialState,
  reducers: {
    reset: (state) => initialState,
    setKorisnik(state, action: PayloadAction<Korisnik>) {
      return { ...state, ...action.payload };
    },
    loadUser: (state, action: PayloadAction<Korisnik>) => {
      return { ...action.payload };
    },
    logOutUser: () => {
      return { ...initialState };
    },
    setTokens: (state, action: PayloadAction<string>) => {
      return { ...state, accessToken: action.payload };
    },
    setCredentialsError: (state, action: PayloadAction<string>) => {
      return { ...state, credentialsError: action.payload };
    },
  },
});

export const { reset, setKorisnik, loadUser, logOutUser, setTokens, setCredentialsError } = korisnikSlice.actions;

export default korisnikSlice.reducer;
